<template>
    <div>
        <SettingsCardTitle>
            {{ __('actions.edit_thing', {thing: __('navigation.sale_settings')}) }}
            <template v-slot:subtitle>
                {{ __('actions.manage_payment_providers_and_delivery_settings') }}
            </template>
        </SettingsCardTitle>

        <AcceptStoreTos v-if="!tosAccepted" :store="store"/>

        <div v-if="tosAccepted">
            <FormGroupNew label="youbuyda Shop"
                          :description="__('actions.enable_thing_for', {
                              thing: 'youbuyda.com shop',
                               for: __('general.your_store')
                          })"
                          required
            >
                <Checkbox v-model="settings.sales_enabled">
                    {{ __('actions.enable_thing', {thing: __('general.sales')}) }}
                </Checkbox>
            </FormGroupNew>

            <FormGroupNew :label="__('sale.customer_support_requests')"
                          :description="__('sale.customer_support_email_description')"
                          :error="settings.errors.email_contact"
                          required
            >
                <input type="email" class="form-control" v-model="settings.email_contact" :disabled="!settings.sales_enabled">
            </FormGroupNew>

            <DividerDotted/>

            <div class="font-weight-bold h3 mb-3">
                {{ __('general.payment_provider') }}
            </div>
            <PaymentProvider :inactive-payment-providers="inactivePaymentProviders"
                             :active-payment-providers="activePaymentProviders"
                             :has-stripe-account="hasStripeAccount"
                             :details-submitted="detailsSubmitted"
                             :charges-enabled="chargesEnabled"
                             :stripe-is-ready="stripeIsReady"
            />

            <DividerDotted class="mt-10"/>

            <div class="font-weight-bold h3 mb-3">
                {{ __('sale.delivery_settings') }}
            </div>
            <Shipping :tos-accepted="tosAccepted"
                      :store-uuid="store.id"
                      :has-stripe-account="hasStripeAccount"
                      :stripe-is-ready="stripeIsReady"
                      v-model="settings"
            />
        </div>

        <div v-if="tosAccepted">
            <DividerDotted class="mb-3"/>
            <SaveAndEnableButton :for="settings" @click="save"/>
        </div>
    </div>
</template>

<script>
import Navigation from './Nav/Navigation.vue'
import PaymentProvider from '@components/Store/Includes/Tabs/PaymentProvider.vue'
import Shipping from '@components/Store/Includes/Tabs/Shipping.vue'
import SettingsCardTitle from "@components/Form/SettingsCardTitle.vue";
import DividerDotted from "@components/Form/DividerDotted.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import AcceptStoreTos from "@components/Store/AcceptStoreTos.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import Checkbox from "@components/Form/Checkbox.vue";

export default {
    layout: Navigation,

    components: {
        Checkbox,
        FormGroupNew,
        AcceptStoreTos,
        SaveAndEnableButton,
        DividerDotted,
        SettingsCardTitle,
        Shipping,
        PaymentProvider
    },

    props: {
        store: Object,
        tosAccepted: Boolean,
        saleSettings: Object,
        stripeInfos: Object,
        activePaymentProviders: Array,
        inactivePaymentProviders: Array,
    },

    data() {
        return {
            settings: this.$inertia.form(this.saleSettings)
        }
    },

    methods: {
        save() {
            this.settings.post(this.$route('sales-settings.update', this.store.id), {
                preserveScroll: true
            });
        }
    },

    computed: {
        hasStripeAccount() {
            return this.stripeInfos.hasStripeAccount
        },

        detailsSubmitted() {
            return this.stripeInfos.detailsSubmitted
        },

        chargesEnabled() {
            return this.stripeInfos.chargesEnabled
        },

        stripeIsReady() {
            return this.stripeInfos.stripeIsReady
        }
    }
}
</script>
